export default "__VITE_ASSET__DIh7df19__"